import { render, staticRenderFns } from "./Uploaderb.vue?vue&type=template&id=1be93009&scoped=true&"
import script from "./Uploaderb.vue?vue&type=script&lang=js&"
export * from "./Uploaderb.vue?vue&type=script&lang=js&"
import style0 from "./Uploaderb.vue?vue&type=style&index=0&id=1be93009&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be93009",
  null
  
)

export default component.exports